import { useState, useEffect } from 'react'
import { stringify } from 'querystringify'

import styles from './instagramembed.css'

const process = () => {
  if (typeof window.instgrm !== 'undefined') {
    window.instgrm.Embeds.process()
  } else {
    setTimeout(process, 250)
  }
}

const fetchSdkAndProcess = () => {
  const elem = document.getElementById('instagram')
  if (!elem) {
    const script = document.createElement('script')
    script.src = 'https://www.instagram.com/embed.js'
    script.async = true
    script.id = 'instagram'
    if (document.head) {
      document.head.appendChild(script)
    }
  }
  process()
}

const InstagramEmbed = ({
  value: { url, hide_caption, max_width },
}: {
  value: {
    url: string
    hide_caption: boolean
    max_width: number
  }
}) => {
  const [html, setHtml] = useState('')

  const handleFetchSuccess = response => setHtml(response.html)

  const handleFetchError = () => setHtml('<p style="font: 500 0.9em inherit; color: gray;">Failed to load instagram embed</p>')

  useEffect(() => {
    const fetchEmbed = query => {
      fetch(`https://graph.facebook.com/v8.0/instagram_oembed/?${query}`).then(response => {
        return response.json().then(handleFetchSuccess).catch(handleFetchError)
      })
    }
    fetchEmbed(
      stringify({
        url,
        omitScript: true,
        hidecaption: hide_caption,
        maxwidth: typeof max_width === 'number' && max_width >= 320 ? max_width : undefined,
        access_token: '404479463282688|a5816a1f9b7030e8aedc761e2578c4eb',
      }),
    )
  }, [url, hide_caption, max_width])

  useEffect(() => {
    fetchSdkAndProcess()
  }, [html])
  return <div className={styles.wrapper} dangerouslySetInnerHTML={{ __html: html }} />
}

export default InstagramEmbed
